const Remy3dFeaturesStatic = () => {
    return (
      <>
        <div class="gallery_containerThree-static">  

        <div class="gallery_item">
            <p class="gallery-tag">Feature</p>
            <a href="https://open.spotify.com/track/1cBIAPbkt6Mb4qrbTzrvuq?si=cd741088348c4148" target="_blank" rel="noopener noreferrer">
              <img src="https://i.scdn.co/image/ab67616d0000b273f2f2bf001f382b16315b7ac3" width="100%" alt=""/><br/>
              <p class="gallery-text">
                <strong>Kawaii Ry & Lugosi - Schoolin' (feat. Remy3D)</strong><br/>
                (prod. Meauxminy)
              </p>
            </a>
          </div>

        <div class="gallery_item">
            <p class="gallery-tag">Feature</p>
            <a href="https://open.spotify.com/track/3JgFOUJ9Wf9hgYKuiTx3O7?si=282f46548bf64538" target="_blank" rel="noopener noreferrer">    
              <img src="https://i1.sndcdn.com/artworks-M0Rzq7jdHWKlMJHT-ormDZw-t500x500.jpg" width="100%" alt=""/><br/>
              <p class="gallery-text">
                <strong>Kawaii Ry - heart cold (feat. Remy3D)</strong><br/>
                (prod. Semaj)
              </p>
            </a>
          </div>

        <div class="gallery_item">
            <p class="gallery-tag">Feature</p>
            <a href="https://open.spotify.com/track/6J8EV3qFmpYIm72K9QIzT0?si=865666293b2247c4" target="_blank" rel="noopener noreferrer">    
              <img src="https://i1.sndcdn.com/artworks-Zy2efuUGXKFOmrQy-zGctQw-t500x500.jpg" width="100%" alt=""/><br/>
              <p class="gallery-text">
                <strong>Kawaii Ry - Hellscape Zone (feat. Remy3D)</strong><br/>
                (prod. Sorrowbringer)
              </p>
            </a>
          </div>

          <div class="gallery_item">
            <p class="gallery-tag">Feature</p>
            <a href="https://open.spotify.com/track/3Pu4JB8hXOc8JVK3rZg01e?si=f95bf20ff6824918" target="_blank" rel="noopener noreferrer">    
              <img src="https://i1.sndcdn.com/artworks-TNXzY0ZussIZo0q4-MWqNsg-t500x500.jpg" width="100%" alt=""/><br/>
              <p class="gallery-text">
                <strong>Kawaii Ry - Falcon Punch (feat. Remy3D, Nyquil)</strong><br/>
                (prod. Dabeast Beats)
              </p>
            </a>
          </div>

          <div class="gallery_item">
            <p class="gallery-tag">Feature</p>
            <a href="https://open.spotify.com/track/0L2XDwH0qblogeYb5samn4?si=e8aa8ada06654af2" target="_blank" rel="noopener noreferrer">    
              <img src="https://i1.sndcdn.com/artworks-CseIW0uhch23VMdR-gYOhLg-t500x500.jpg" width="100%" alt=""/><br/>
              <p class="gallery-text">
                <strong>Kawaii Ry - Voices (feat. Remy3D)</strong><br/>
                (prod. MDST)
              </p>
            </a>
          </div>

          <div class="gallery_item">
            <p class="gallery-tag">Feature</p>
            <a href="https://open.spotify.com/track/4hs0rbKF12TXTgP2cBrUXE?si=6d8428dd434f42cd" target="_blank" rel="noopener noreferrer">    
              <img src="https://i1.sndcdn.com/artworks-97rj9GPmqRUF0kdA-0VzT6g-t500x500.jpg" width="100%" alt=""/><br/>
              <p class="gallery-text">
                <strong>Kawaii Ry - Lost Her (feat. Remy3D)</strong><br/>
              </p>
            </a>
          </div>

          <div class="gallery_item">
            <p class="gallery-tag">Feature</p>
            <a href="https://open.spotify.com/track/1N5P23Sk9thMA4CekfpyZo?si=634f183669d94262" target="_blank" rel="noopener noreferrer">    
              <img src="https://i1.sndcdn.com/artworks-hI5gzMPuB1sIYlEr-F9ff4A-t500x500.jpg" width="100%" alt=""/><br/>
              <p class="gallery-text">
                <strong>Kawaii Ry - Tear Drops (feat. Remy3D)</strong><br/>
                (prod. youngfyebeatz)
              </p>
            </a>
          </div> 

        </div>
      </>
    );
  };
  export default Remy3dFeaturesStatic;